import {axios} from "@/api/config";
// 查询危险源管理列表
export function listBPlan(params) {
  return axios.get(`/bPlan/list`, params, true);
}

// 查询危险源管理详细
export function getBPlan(id) {
  return axios.get(`/bPlan/${id}`, id, true)
}

// 新增危险源管理
export function addBPlan(params) {
  return axios.post('/bPlan/addBPlan', params, false);
}

// 修改危险源管理
export function updateBPlan(params) {
  return axios.post('/bPlan/editBPlan', params, false);
}


// 删除危险源管理
export function delBPlan(id) {
  return axios.delete(`/bPlan/${id}`, true)
}

